export class ForbiddenError extends Error {
    constructor(message) {
        super(message);
        this.name = 'ForbiddenError';
    }
}
//# sourceMappingURL=forbidden_error.js.map